import * as React from "react";
import {Component} from "react";
import styles from "../../styles/wizards/superadmin/AddCountryWizard.scss";
import autobind from "autobind-decorator";
import AddCountryIcon from "../../assets/images/add-country-64x64.svg";
import {mapStateToProps, setTableParams, validateForm} from "../../core/utils";
import {withRouter} from "react-router";
import {setNotification} from "../../redux/actions/general/notification";
import {createCountry, listCountries} from "../../redux/actions/table/superadmin/countries";
import AddCountryForm from "../../forms/superadmin/add_country_wizard/AddCountryForm";
import * as _ from "lodash";

@withRouter
@mapStateToProps(state => ({
    table: state.table["superadmin_countries"],
}))
class AddCountryWizard extends Component {
    @autobind
    _handleSubmit(formData) {
        const {edit} = formData;
        
        return validateForm(
            createCountry(formData).then(({response}) => {
                listCountries().then(() => {
                    if(edit) {
                        setTableParams('superadmin_countries', {
                            clicked_row: response.data.id
                        });
                    }
                });

                setTableParams('superadmin_countries', {
                    actioned_row: undefined,
                    selected_rows: []
                });

                this.props.onClose();

                setNotification("You have successfully added a new country.");
            })
        );
    }

    render() {
        return (
            <>
                <div className={styles.header}>
                    <div className={styles.left}>
                        <span>Add country</span>
                        <span>Add country to the application</span>
                    </div>
                    <div className={styles.right}>
                        <AddCountryIcon />
                    </div>
                </div>
                <div className={styles.body}>
                    <AddCountryForm onSubmit={this._handleSubmit} />
                </div>
            </>
        );
    }
}

export default AddCountryWizard;